namespace Ir.Components.Workbook.Settings.MapSettings {
    interface IViewModel {
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<ITabOrWidget>;
        activeTabItem: KnockoutObservable<number>;
        itemConfig: BaseItemConfig;

        metricParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        fieldParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        formattingRuleParams: Ir.Components.Workbook.Settings.Items.FormattingRuleSetting.IFormattingRuleSettingParams;

        colorizationOptions: DevExpress.ui.dxSelectBox.Properties;
        gradientRangesOptions: DevExpress.ui.dxNumberBox.Properties;
        zoomingEnabledOptions: DevExpress.ui.dxSwitch.Properties;
        panningEnabledOptions: DevExpress.ui.dxSwitch.Properties;
        showLegendOptions: DevExpress.ui.dxSwitch.Properties;
        titleOptions: DevExpress.ui.dxTextBox.Properties;
        formatOptions: Ir.Components.Workbook.Settings.Items.MetricFormatSetting.IMetricFormatSettingParams;
        unitFormatOptions: Ir.Components.Workbook.Settings.Items.UnitFormatSetting.IUnitFormatSettingParams;
        decimalPlacesOptions: Ir.Components.Workbook.Settings.Items.DecimalPlacesSetting.IParams;
        mapSelectOptions: DevExpress.ui.dxSelectBox.Properties;
        attributeNameOptions: DevExpress.ui.dxSelectBox.Properties;

        isCustomMap: KnockoutComputed<boolean>;

        fieldLabel: KnockoutComputed<string>;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        this.config = params.config as WorkbookConfig;
        this.activeTabOrWidget = params.activeTabOrWidget;
        this.activeTabItem = params.activeTabItem;
        this.itemConfig = this.activeTabOrWidget().itemConfig();
        let config = this.itemConfig as MapConfig;
        let mapWidget = this.activeTabOrWidget().widget.getWidget<MapWidget>() as MapWidget;
        
        this.fieldLabel = ko.computed(function () {
            return mapWidget.result.fieldLabel();
        });

        var self = this;
        this.metricParams = {
            label: "Metric",
            type: MappingPopoverTypeEnum.Metrics,
            id: config.metric
        };

        this.fieldParams = {
            label: this.fieldLabel,
            type: MappingPopoverTypeEnum.NonMetricsNonDates,
            id: config.field,
            autoGrouping: config.fieldAutoGrouping
        };

        this.formattingRuleParams = {
            label: "Formatting Rule",
            id: config.formattingRule
        }

        this.colorizationOptions = {
            displayExpr: 'text',
            valueExpr: 'id',
            value: config.colorization,
            items: [
                { id: 'gradient', text: 'Gradient' },
                { id: 'range', text: 'Range' }
            ],
            width: 110,
        };
        this.gradientRangesOptions = {
            format: '0#',
            value: config.gradientRanges as any,
            step: 1,
            showSpinButtons: isMobile() ? false : true,
            min: 2,
            max: 200,
            width: 80,
        };
        this.zoomingEnabledOptions = {
            value: config.zoomingEnabled as any
        };
        this.panningEnabledOptions = {
            value: config.panningEnabled as any
        };
        this.showLegendOptions = {
            value: config.legend.showLegend as any
        };
        this.titleOptions = {
            value: config.legend.title as any,
            width: 117
        };

        this.mapSelectOptions = {
            displayExpr: 'name',
            valueExpr: 'id',
            value: config.source,
            items: mapWidget.result.dataSourceMapOptions,
            width: 170,
        }

        this.formatOptions = {
            value: config.legend.format
        };
        this.decimalPlacesOptions = {
            value: config.legend.decimalPlaces
        };
        this.unitFormatOptions = {
            value: config.legend.unitFormat
        };

        this.isCustomMap = ko.computed(function (this: IViewModel) {
            return mapWidget.isCustomMap(config.source());
        }, this);

        this.attributeNameOptions = {
            value: config.attributeName,
            items: mapWidget.result.attributeNameItems as any,
            width: 150
        };
    }
}